var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Icons'),_c('router-view'),(_vm.notslist && _vm.notslist.length)?_c('div',{staticClass:"notice__snackbars"},_vm._l((_vm.notslist),function(not){return _c('NoticeBar',{key:not.id,attrs:{"notice":not}})}),1):_vm._e(),_c('NoNotificationModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }